class form {
	constructor(config) {
		this.config = Object.assign({
			extraFieldsCheckbox: '[extrafields]'
		}, config);

		this.init();
	}

	init() {
		this.toggleExtraFields();
		this.addEventListerners();
	}

	addEventListerners() {
		$(this.config.extraFieldsCheckbox).on('change', this.inputStateChanged.bind(this))
	}

	inputStateChanged(e) {
		let $input = $(e.currentTarget);
		this.toggleExtraField($input);
	}

	toggleExtraFields() {
		$(this.config.extraFieldsCheckbox).each((it, el) => {
			let $input = $(el);
			this.toggleExtraField($input);
		});
	}

	toggleExtraField($input) {
		let target = $input.data('target');
		if($input.is(':checked')) {
			$(target).removeClass('d-none');
			$(target).find('input, select, textarea').attr('disabled', false);
			if (target == '#corporate-fields') {
				$(target).find('#company').attr('required', true);
				$(target).find('#vat_number').attr('required', true);
			}
		} else {
			$(target).addClass('d-none');
			$(target).find('input, select, textarea').attr('disabled', true);
			if (target == '#corporate-fields') {
				$(target).find('#company').removeAttr('required');
				$(target).find('#vat_number').removeAttr('required', true);
			}
		}
	}
}

export default new form();
